export default {
  placeholder: 'Søg virksomhed...',
};
